import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CloudRain = createReactComponent("CloudRain", ["svg", defaultAttributes, [["line", {
  x1: "16",
  y1: "13",
  x2: "16",
  y2: "21",
  key: "1j5n7q"
}], ["line", {
  x1: "8",
  y1: "13",
  x2: "8",
  y2: "21",
  key: "1i6fuc"
}], ["line", {
  x1: "12",
  y1: "15",
  x2: "12",
  y2: "23",
  key: "1ydugz"
}], ["path", {
  d: "M20 16.58A5 5 0 0018 7h-1.26A8 8 0 104 15.25",
  key: "1qxhfx"
}]]]);
export default CloudRain;